import { ApiPaths } from 'services/api/apiPaths';
import RedisApiAxiosInstance from '../../../services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { ApplyAllChangesPayload } from './allowList.types';

export const getAllowList = (rcpId: number) =>
  RedisApiAxiosInstance.get(`${ApiPaths.RCPS}/${rcpId}/whitelist`);
export const applyAllChanges = ({ rcpId, rcpWhitelist }: ApplyAllChangesPayload) =>
  RedisApiAxiosInstance.put(`${ApiPaths.RCPS}/${rcpId}/whitelist`, { rcpWhitelist });
